// Ausserbetriebsetzung

// state
const state = {
    ifTitle: "",
    ifType: "",
    ifActivityGroup: ""
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
    setIFTitle(state, newValue) {
        state.ifTitle = newValue;
    },
    setIFType(state, newValue) {
        state.ifType = newValue;
    },
    setIFActivityGroup(state, newValue) {
        state.ifActivityGroup = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}